import InputVariableProvider from './InputVariableProvider';

export default {
  __init__: [ 'camundaPlatformInputVariable' ],
  camundaPlatformInputVariable: [ 'type', InputVariableProvider ]
};
